import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!email) {
      setError('Please enter your email');
      return;
    }
    try {
      setIsLoading(true);
      const base = API_BASE_URL.replace(/\/$/, '');
      const res = await fetch(`${base}/api/auth/send-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        // Do not reveal existence of account; show generic message
        setMessage('If the email exists, an OTP has been sent.');
        return;
      }
      setMessage('If the email exists, an OTP has been sent.');
      // Navigate to OTP verification - account will be found by email
      navigate('/reset-password', { state: { email } });
    } catch (e) {
      setMessage('If the email exists, an OTP has been sent.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Forgot Password</h1>
          <p className="text-muted">Enter your email to receive an OTP</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className={`form-input ${error ? 'error' : ''}`}
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
            />
            {error && <span className="error-message">{error}</span>}
          </div>

          <button type="submit" className={`btn btn-primary btn-block ${isLoading ? 'loading' : ''}`} disabled={isLoading}>
            {isLoading ? 'Sending...' : 'Send OTP'}
          </button>

          {message && (
            <div style={{ marginTop: 12 }} className="secure-notice">{message}</div>
          )}

          <button type="button" className="btn btn-secondary btn-block" style={{ marginTop: 12 }} onClick={() => navigate('/login')}>
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;


